<template>
  <div class="list">
    <cc-header-nav title="设置">
      <template slot="right">
        <div  class="ellipsis">
          <van-icon class="ellipsis-icon" name="ellipsis" @click.stop="isShowSmallNav = !isShowSmallNav" />
        </div>
      </template>
    </cc-header-nav>
    <cc-main>
    <div class="wrapper">
      <van-cell-group>
        <van-cell title="用户协议" is-link to="/policy/100" />
        <van-cell title="隐私条款" is-link to="/policy/101" />
        <van-cell title="投诉建议" is-link url="/user/proposallist" />
      </van-cell-group>
    </div>
    </cc-main>
     <cc-small-nav v-model="isShowSmallNav"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { CellGroup, Cell, Icon } from 'vant'
Vue.use(CellGroup)
  .use(Cell)
  .use(Icon)
export default {
  name: 'news-list',
  data () {
    return {
      isShowSmallNav: false
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {},
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "~styles/var.scss";
.ellipsis{
  width: 100%;
  height: 100%;
  @include center();
  &-icon{
    transform: rotate(90deg);
  }
}
</style>
